import React, { Component } from 'react';
import { InputGroup, Button, Row, Col, Image, Table } from 'react-bootstrap';
import NumericTextboxComponent from 'react-numeric-textbox';


// TODO Change to NumericTextboxComponent!!
class StemInput extends Component {

    handleChange = (e) => {
        this.props.onChange(e, this.props.id);
    }

    render() {
        return (
            <InputGroup className="mb-3">
                <InputGroup.Prepend>
                    <InputGroup.Text>{this.props.id}</InputGroup.Text>
                </InputGroup.Prepend>
                {/* <FormControl defaultValue={this.props.value} onChange={this.props.onChange} id={this.props.id} /> */}
                {/*                 <NumericTextboxComponent className="form-control"
                    min={0}
                    //max={20}
                    step={0.1}
                    precision={2}
                    defaultValue={this.props.value}
                    strict={true}
                    onChange={this.handleChange}
                    value={0}
                    autoCorrect={true}
                    id={this.props.id}
                /> */}

                <NumericTextboxComponent
                    className="form-control"
                    min={0}
                    decimals={1}
                    value={0}
                    format={'0.0'}
                    onChange={this.handleChange}
                    autoCorrect={true}
                />

                <InputGroup.Append>
                    <InputGroup.Text>cm</InputGroup.Text>
                </InputGroup.Append>
            </InputGroup>
        )
    }
}

class StemInputList extends Component {
    render() {
        let numbers = this.props.numbers;

        var listItems = numbers.map((number, index) =>
            <StemInput key={index} id={index + 1}
                value={number} onChange={this.props.onChange} />
        )
        return (<div>{listItems}</div>
        )
    }
}

class SRZCalculatorCircumference extends Component {
    constructor(props) {
        super(props);

        this.state = {
            srzradius: 0,
            srzarea: 0,
            DatBase: 0
        }
        this.updateSRZ = this.updateSRZ.bind(this)
    }

    // Run calcs for the first time
    componentDidMount = () => {
        this.updateSRZ(0)
    }

    updateSRZ = (e) => {
        var circ = Number(e)
        var DatBase = circ / Math.PI
        var srzradius = Math.pow(DatBase / 2, 0.42) * 0.64

        if (srzradius <= 1.5) {
            srzradius = 1.5
        }

        var srzarea = srzradius * srzradius * Math.PI

        this.setState({
            srzradius: srzradius,
            srzarea: srzarea,
            DatBase: DatBase
        })

        this.props.pCallback({ srz: srzradius })
    }

    render() {
        return (<div>
            <label>Circumference (cm) measured immediately above the root buttress.</label>
            <InputGroup className="mb-3">
                <NumericTextboxComponent
                    className="form-control"
                    min={0}
                    decimals={1}
                    value={0}
                    format={'0.0'}
                    onChange={this.updateSRZ}
                    autoCorrect={true}
                />
                <InputGroup.Append>
                    <InputGroup.Text id="basic-addon2">m</InputGroup.Text>
                </InputGroup.Append>
            </InputGroup>
            <Table responsive>
                <tbody>
                    <tr>
                        <td>DAB (cm)</td>
                        <td class="text-right">{this.state.DatBase.toFixed(1)}</td>
                    </tr>
                    <tr>
                        <td>SRZ radius (m)</td>
                        <td class="text-right">{this.state.srzradius.toFixed(1)}</td>
                    </tr>
                    <tr>
                        <td>SRZ area (m²)</td>
                        <td class="text-right">{this.state.srzarea.toFixed(1)}</td>
                    </tr>
                </tbody>
            </Table>
        </div>
        )
    }
}

class SRZCalculatorDiameter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            srzradius: 0,
            srzarea: 0,
        }
        this.updateSRZ = this.updateSRZ.bind(this)
    }

    // Run calcs for the first time
    componentDidMount = () => {
        this.updateSRZ(0)
    }

    updateSRZ = (e) => {
        var DatBase = Number(e)
        var srzradius = Math.pow(DatBase / 2, 0.42) * 0.64

        if (srzradius <= 1.5) {
            srzradius = 1.5
        }

        var srzarea = srzradius * srzradius * Math.PI

        this.setState({
            srzradius: srzradius,
            srzarea: srzarea
        })

        this.props.pCallback({ srz: srzradius })
    }

    render() {
        return (<div>
            <label>Diameter (cm) measured immediately above the root buttress.</label>
            <InputGroup className="mb-3">
                <NumericTextboxComponent
                    className="form-control"
                    min={0}
                    decimals={1}
                    value={0}
                    format={'0.0'}
                    onChange={this.updateSRZ}
                    autoCorrect={true}
                />
                <InputGroup.Append>
                    <InputGroup.Text id="basic-addon2">m</InputGroup.Text>
                </InputGroup.Append>
            </InputGroup>
            <Table responsive>
                <tbody>
                    <tr>
                        <td>SRZ radius (m)</td>
                        <td class="text-right">{this.state.srzradius.toFixed(1)}</td>
                    </tr>
                    <tr>
                        <td>SRZ area (m²)</td>
                        <td class="text-right">{this.state.srzarea.toFixed(1)}</td>
                    </tr>
                </tbody>
            </Table>
        </div>
        )
    }
}


// class MSCalculator extends Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             values: [0, 0, 0],
//             result: 0,
//             srzradius: 0,
//             srzarea: 0,
//             tpzradius: 0,
//             tpzarea: 0
//         }

//         this.calculate = this.calculate.bind(this)
//         this.updateValues = this.updateValues.bind(this)
//     }

//     calculate = (e) => {
//         try {

//             let total = 0;

//             for (var i = 0; i < this.state.values.length; i += 1) {
//                 total += Math.pow(this.state.values[i], 2)
//             }
//             total = Math.sqrt(total).toFixed(1)

//             this.setState({
//                 result: Number(total)
//             })
//         } catch (e) {
//             this.setState({
//                 result: "error"
//             })
//         }
//     };

//     updateValues = (e) => {

//         try {

//             let values = [...this.state.values];
//             values[e.currentTarget.id - 1] = Number(e.currentTarget.value)
//             this.setState({ values }, this.calculate)

//         } catch (e) {
//             this.setState({
//                 result: "error"
//             })

//         }
//     };

//     SRZCalc = () => {
//         switch (this.props.measurementType) {
//             case 1:
//                 return <SRZCalculatorDiameter pCallback={this.props.pCallback} />;
//             case 2:
//                 return <SRZCalculatorCircumference pCallback={this.props.pCallback} />;
//             default:
//                 return "Error...";
//         }
//     }

//     addStem = () => {
//         let values = [...this.state.values];
//         values.push(0)
//         this.setState({ values })
//     }

//     deleteStem = () => {
//         if (this.state.values.length > 2) {
//             let values = [...this.state.values];
//             values.pop()
//             this.setState({ values }, this.calculate)
//         }
//     }

//     /*
//     resetStem = () => {
//         this.setState({ values: [0, 0, 0, 0] })
//     }
//     */

//     render() {
//         return (
//             <div>
//                 <Row>
//                     <Col>
//                         <label>Diameter (cm) of stems measured at 1.4m above ground.</label>
//                         <StemInputList numbers={this.state.values} onChange={this.updateValues} />
//                         <center>
//                             <Button onClick={this.addStem}>Add stem</Button> &nbsp;&nbsp;
//                             <Button onClick={this.deleteStem} variant="danger">Delete</Button>
//                         </center>
//                         <p></p>
//                         <Table responsive>
//                             <tbody>
//                                 <tr>
//                                     <td>Combined DBH (cm)</td>
//                                     <td class="text-right">{this.state.result.toFixed(1)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>TPZ radius (m)</td>
//                                     <td class="text-right">{this.state.tpzradius.toFixed(1)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>TPZ area (m²)</td>
//                                     <td class="text-right">{this.state.tpzarea.toFixed(1)}</td>
//                                 </tr>
//                             </tbody>
//                         </Table>
//                         {this.SRZCalc()}
//                     </Col>
//                     <Col sm={12} md={6} lg={4}>
//                         <Image src="https://images.squarespace-cdn.com/content/5df324d37e6e374ed0213297/1589786574724-AMLCFNEBQUCCCMR47LTP/Multi-stem+DBH_DAB+graphic.png" width="300" />
//                         Measuring DBH/DAB for a multi stemmed tree that forks below 1.4m above ground.<sup>2</sup>
//                     </Col>
//                     <Col sm={0} md={2} lg={2}></Col>
//                 </Row>
//             </div>
//         )
//     }

// }

class MSCalculatorDiameter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            values: [0, 0, 0],
            result: 0,
            srzradius: 0,
            srzarea: 0,
            tpzradius: 0,
            tpzarea: 0
        }

        this.calculate = this.calculate.bind(this)
        this.updateValues = this.updateValues.bind(this)
    }

    componentDidMount = () => {
        this.calculate(0)
    }

    calculate = (e) => {
        try {

            let total = 0;

            for (var i = 0; i < this.state.values.length; i += 1) {
                total += Math.pow(this.state.values[i], 2)
            }
            total = Math.sqrt(total).toFixed(1)

            this.setState({
                result: Number(total)
            })

            var dbh = total

            var tempTPZradius = dbh * 12 / 100

            if (tempTPZradius <= 2) {
                tempTPZradius = 2;
            } else if (tempTPZradius >= 15) {
                tempTPZradius = 15;
            }

            var tpzarea = tempTPZradius * tempTPZradius * Math.PI

            this.setState({
                dbh: dbh,
                tpzradius: tempTPZradius,
                tpzarea: tpzarea
            })

            this.props.pCallback({ tpzradius: tempTPZradius, tpzarea: tpzarea })

        } catch (e) {
            this.setState({
                result: "error"
            })
        }
    };

    updateValues = (e, id) => {

        try {
            console.log(e, id)
            let values = [...this.state.values];
            values[id - 1] = Number(e)
            this.setState({ values }, this.calculate)

        } catch (e) {
            this.setState({
                result: "error"
            })

        }
    };

    SRZCalc = () => {
        switch (this.props.measurementType) {
            case 1:
                return <SRZCalculatorDiameter pCallback={this.props.pCallback} />;
            case 2:
                return <SRZCalculatorCircumference pCallback={this.props.pCallback} />;
            default:
                return "Error...";
        }
    }

    addStem = () => {
        let values = [...this.state.values];
        values.push(0)
        this.setState({ values })
    }

    deleteStem = () => {
        if (this.state.values.length > 2) {
            let values = [...this.state.values];
            values.pop()
            this.setState({ values }, this.calculate)
        }
    }

    /*
    resetStem = () => {
        this.setState({ values: [0, 0, 0, 0] })
    }
    */

    render() {
        return (
            <div>
                <Row>
                    <Col xs={{ order: 12 }} sm={{ order: 12 }}>
                        <label>Diameter (cm) of stems measured at 1.4m above ground.</label>
                        <StemInputList numbers={this.state.values} onChange={this.updateValues} />
                        <center>
                            <Button onClick={this.addStem}>Add stem</Button> &nbsp;&nbsp;
                            <Button onClick={this.deleteStem} variant="danger">Delete</Button>
                        </center>
                        <p></p>
                        <Table responsive>
                            <tbody>
                                <tr>
                                    <td>Combined DSH (cm)</td>
                                    <td class="text-right">{this.state.result.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ radius (m)</td>
                                    <td class="text-right">{this.state.tpzradius.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ area (m²)</td>
                                    <td class="text-right">{this.state.tpzarea.toFixed(1)}</td>
                                </tr>
                            </tbody>
                        </Table>
                        {this.SRZCalc()}
                    </Col>
                    <Col xs={{ span: 12, order: 'first' }} sm={{ span: 12, order: 'first' }} md={{ span: 4, order: 12 }} lg={{ span: 4, order: 12 }}>
                    <br />
                        <Image src="https://storage.googleapis.com/as4970-2025/Multi_stem_DSH_DAB_graphic.png" height="300" />
                        <p><small>Measuring DSH/DAB for a multi stemmed tree that forks below 1.4m above ground.<sup>1</sup></small></p>
                    </Col>
                    <Col xs={0} sm={0} md={{ span: 2, order: 'last' }} lg={{ span: 2, order: 'last' }}></Col>
                </Row>
            </div>
        )
    }

}

class MSCalculatorCircumference extends Component {
    constructor(props) {
        super(props);

        this.state = {
            values: [0, 0, 0],
            result: 0,
            srzradius: 0,
            srzarea: 0,
            tpzradius: 0,
            tpzarea: 0
        }

        this.calculate = this.calculate.bind(this)
        this.updateValues = this.updateValues.bind(this)
    }

    componentDidMount = () => {
        this.calculate(0)
    }

    calculate = (e) => {
        try {

            let total = 0;

            for (var i = 0; i < this.state.values.length; i += 1) {
                total += Math.pow(this.state.values[i] / Math.PI, 2)
            }
            total = Math.sqrt(total).toFixed(1)

            this.setState({
                result: Number(total)
            })

            var dbh = total

            var tempTPZradius = dbh * 12 / 100

            if (tempTPZradius <= 2) {
                tempTPZradius = 2;
            } else if (tempTPZradius >= 15) {
                tempTPZradius = 15;
            }

            var tpzarea = tempTPZradius * tempTPZradius * Math.PI

            this.setState({
                dbh: dbh,
                tpzradius: tempTPZradius,
                tpzarea: tpzarea
            })

            this.props.pCallback({ tpzradius: tempTPZradius, tpzarea: tpzarea })

        } catch (e) {
            this.setState({
                result: "error"
            })
        }
    };

    updateValues = (e, id) => {

        try {
            console.log(e, id)
            let values = [...this.state.values];
            values[id - 1] = Number(e)
            this.setState({ values }, this.calculate)

        } catch (e) {
            this.setState({
                result: "error"
            })

        }
    };

    SRZCalc = () => {
        switch (this.props.measurementType) {
            case 1:
                return <SRZCalculatorDiameter pCallback={this.props.pCallback} />;
            case 2:
                return <SRZCalculatorCircumference pCallback={this.props.pCallback} />;
            default:
                return "Error...";
        }
    }

    addStem = () => {
        let values = [...this.state.values];
        values.push(0)
        this.setState({ values })
    }

    deleteStem = () => {
        if (this.state.values.length > 2) {
            let values = [...this.state.values];
            values.pop()
            this.setState({ values }, this.calculate)
        }
    }

    /*
    resetStem = () => {
        this.setState({ values: [0, 0, 0, 0] })
    }
    */

    render() {
        return (
            <div>
                <Row>
                    <Col xs={{ order: 12 }} sm={{ order: 12 }}>
                        <label>Circumference (cm) of stems measured at 1.4m above ground.</label>
                        <StemInputList numbers={this.state.values} onChange={this.updateValues} />
                        <center>
                            <Button onClick={this.addStem}>Add stem</Button> &nbsp;&nbsp;
                            <Button onClick={this.deleteStem} variant="danger">Delete</Button>
                        </center>
                        <p></p>
                        <Table responsive>
                            <tbody>
                                <tr>
                                    <td>Combined DSH (cm)</td>
                                    <td class="text-right">{this.state.result.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ radius (m)</td>
                                    <td class="text-right">{this.state.tpzradius.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ area (m²)</td>
                                    <td class="text-right">{this.state.tpzarea.toFixed(1)}</td>
                                </tr>
                            </tbody>
                        </Table>
                        {this.SRZCalc()}
                    </Col>
                    <Col xs={{ span: 12, order: 'first' }} sm={{ span: 12, order: 'first' }} md={{ span: 4, order: 12 }} lg={{ span: 4, order: 12 }}>
                    <br />
                        <Image src="https://storage.googleapis.com/as4970-2025/Multi_stem_DSH_DAB_graphic.png" height="300" />
                        <p><small>Measuring DSH/DAB for a multi stemmed tree that forks below 1.4m above ground.<sup>1</sup></small></p>
                    </Col>
                    <Col xs={0} sm={0} md={{ span: 2, order: 'last' }} lg={{ span: 2, order: 'last' }}></Col>
                </Row>
            </div>
        )
    }

}

export { MSCalculatorDiameter, MSCalculatorCircumference };